import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ApiResponse, ApiPagedResponse, PaginationInfo } from "app/client-core/api-response-models";
import { ApiService } from "../api.service";
import { Bucket } from '../dtos/buckets.model';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { SectorDto } from '../dtos/sectors.model';

@Injectable()
export class TasksService {
    taskStatusChanged: Subject<any>;
    constructor(private apiService: ApiService,
       private router: Router) {
           this.taskStatusChanged = new Subject();
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getGeneralInformation(params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        return this.apiService.get<ApiPagedResponse<SectorDto>>('tasks/general-info', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getActionRequired(params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        return this.apiService.get<ApiPagedResponse<SectorDto>>('tasks/action-required', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getInProgress(params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        return this.apiService.get<ApiPagedResponse<SectorDto>>('tasks/in-progress', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getComplete(params?: any): Observable<ApiResponse<ApiPagedResponse<SectorDto>>> {
        return this.apiService.get<ApiPagedResponse<SectorDto>>('tasks/complete', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getSummary(params?: any): Observable<ApiResponse<any>> {
        return this.apiService.get<any>('tasks/summary', params);
    }

    /**
     * Returns lookup list of projects
     * @param params
     */
    getInfo(id): Observable<ApiResponse<any>> {
        return this.apiService.get<any>(`tasks/${id}/timeline`, {});
    }

    markAsCompleted(id): Observable<ApiResponse<any>> {
        return this.apiService.post<any>(`tasks/${id}/mark-as-completed`, {});
    }
}



// WEBPACK FOOTER //
// ./src/app/client-core/services/tasks.service.ts